export default __webpack_public_path__ + "static/media/ArtKoch.f517af70.png";